import { render, staticRenderFns } from "./dkDetail.vue?vue&type=template&id=226c2891&scoped=true"
import script from "./dkDetail.vue?vue&type=script&lang=js"
export * from "./dkDetail.vue?vue&type=script&lang=js"
import style0 from "./dkDetail.vue?vue&type=style&index=0&id=226c2891&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c2891",
  null
  
)

export default component.exports